import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

export const UpdateSYP = gql`
  mutation UpdateSYP($input: UpdateSYPInput!) {
    updateSYP(input: $input) {
      __typename
      ... on UpdateSYPSuccess {
        key
        isFirstTime
        successTitle: title
        successMessage: message
        syp {
          id
          percentage
        }
      }
      ... on UpdateSYPError {
        ...error
      }
    }
  }
  ${error}
`;
